import { Link } from "react-router-dom"
import { AdminToggle } from "./AdminToggle"

export const AdminLinks: React.FC = () => {
  return <>
    <AdminToggle>Admin: <Link to="/admin">System Parameters</Link> | <Link to="/splash">Landing Page</Link> | </AdminToggle>
  </>
}